module.exports = __webpack_public_path__ + "static/media/spotify_icon.04ab600d.png";